import { encryptPayload } from "@/utils/cryptoUtils";
import { getPublicKey } from "@/api/request-encoding/getPublicKey";

export const sendAadhaarOTP = async (aadhar_number) => {
  try {
    const publicKeyPem = await getPublicKey();
    const encryptedPayload = await encryptPayload({ aadhar_number }, publicKeyPem);

    const response = await fetch(
      `${process.env.NEXT_PUBLIC_BASE_URL}/app/v1/send_aadhar_otp`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify(encryptedPayload),
      }
    );

    if (!response.ok) {
      const errorData = await response.json();
      return Promise.reject(errorData?.detail || "OTP generation failed.");
    }

    return response.json();
  } catch (err) {
    console.error("OTP generation error:", err);
    return Promise.reject("Encryption or request error");
  }
};
